import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certapplyActions } from '../../../../../store/actions'
import Input from '../../../../../module/input'
import PopGoods from './PopGoods'
import history from '../../../../../route/history'
import moment from 'moment'
import { commons } from '../../../../../hook/common'
import { Link } from 'react-router-dom'

/**
 * 구매확인서 2단계 / 구매물품 목록
 */
const Step02 = (props) => {
  const [sumInfo, setSumInfo] = useState({
    totamtcur: 'KRW',
    count: 0,
    amount: 0,
  })
  const [docid, setDocid] = useState()
  const [goodsList, setGoodsList] = useState(props.stepData)
  const [showAddGoods, setShowAddGoods] = useState(false)

  //console.log('props = ', props);
  /**
   * 페이지 진입
   */
  useEffect(() => {
    let id = props.search?.split('=')[1]
    let key = props.search?.split('=')[0]

    if (id && key === '?id') {
      let data = JSON.parse(sessionStorage.getItem(id))

      if (!data || !data.step1.splyprtnum || data?.step1?.splyprtnum?.length <= 0) {
        history.replace('/service/certapply/1?id=' + id)
        return
      }

      setDocid(id)
      data?.step2 && setGoodsList(data.step2)

      if (data.step2?.length > 0) {
        changeSumInfo(data.step2)
      }
    } else {
      if (props.packageId === 0) {
        history.replace('/service/certapply/1')
      }
      if (props.packageId > 0) {
        let idnew = props.totalData?.step1?.docid
        setDocid(idnew)
        props.totalData?.step2 && setGoodsList(props.totalData?.step2)
        if (props.totalData?.step2?.length > 0) {
          changeSumInfo(props.totalData?.step2)
        }
      }
    }
  }, [])

  /**
   * 데이터 갱신
   */
  useEffect(() => {
    if (props.isCalled === true) {
      setGoodsList(props.stepData)
      if (props.stepData?.length > 0) {
        changeSumInfo(props.stepData)
      }
    }
    props.setCalled(false)
  }, [props?.isCalled])

  const changeSumInfo = (list) => {
    let obj = sumInfo
    obj.totamtcur = list[0]?.totamtcur
    let cnt = 0
    let amt = 0

    list.map((item) => {
      item?.gramt && (amt += item.gramt)
      item?.grcnt && (cnt += item.grcnt)
      return true
    })

    obj.amount = commons.addComma(amt)
    obj.count = commons.addComma(cnt)

    //console.log(obj);
    setSumInfo(obj)
  }

  /**
   * 금액단위 변경 처리
   */
  const onChangeCurrency = (e) => {
    const { name, value } = e.target
    if (goodsList[0]?.totamtcur?.length > 0 && goodsList[0]?.totamtcur !== value) {
      return props.confirm({
        title: '확인',
        message: '총금액 단위 변경시 구매물품 목록 금액 단위가 모두 변경됩니다.\n변경하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.updateCurrency(docid, value)
          },
        },
      })
    }
    //console.log(setSumInfo);
    setSumInfo({
      ...sumInfo,
      [name]: value,
    })
  }

  /**
   * 물품추가 팝업 호출
   * @returns {*}
   */
  const openAddGoods = () => {
    //console.log('sumInfo = ', sumInfo);
    if (!sumInfo.totamtcur || sumInfo.totamtcur?.length <= 0) {
      return props.error({ message: '통화코드를 선택해주세요.' })
    }
    setShowAddGoods(true)
  }

  return (
    <React.Fragment>
      {showAddGoods && <PopGoods currency={sumInfo?.totamtcur || 'KRW'} onClose={() => setShowAddGoods(false)} docid={docid} />}

      <h3 className="h3-tit mt30">구매물품 목록 (구매 원료 기재의 내용)</h3>
      <p className="required">※총 금액의 통화 코드를 먼저 선택하신 후, 구매 물품을 등록하시면 합계가 자동 계산됩니다.</p>
      <table className="tbl-write">
        <caption>총 수량, 총 금액 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">
              <em className="required" /> 총 수량
            </th>
            <td>
              <Input
                id="totalCnt"
                name="totalCnt"
                type="text"
                inputTitle={'총수량'}
                value={sumInfo?.count || ''}
                readOnly={true}
                flow={`${window.innerWidth >= 767 ? 'left' : 'up'}`}
                className="form-keyword"
              />
            </td>
          </tr>
          <tr>
            <th scope="row">
              <em className="required" /> 총 금액
            </th>
            <td>
              <span className="input-group">
                <select
                  id="totamtcur"
                  name="totamtcur"
                  className="form-keyword col1"
                  value={sumInfo.totamtcur || 'KRW'}
                  onChange={onChangeCurrency}
                >
                  <option value="">통화코드</option>
                  <option value="USD">USD</option>
                  <option value="KRW">KRW</option>
                </select>
                <Input
                  id="totalAmount"
                  name="totalAmount"
                  type="text"
                  inputTitle={'총 금액'}
                  value={sumInfo?.amount || ''}
                  readOnly={true}
                  flow={`${window.innerWidth >= 767 ? 'left' : 'up'}`}
                  className="form-keyword"
                />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div className="list-header mt40">
        <span className="total-num">총 {goodsList?.length}건</span>
        <span className="right">
          <a
            href="#"
            className="btn-secondary sm"
            onClick={(e) => {
              e.preventDefault()
              openAddGoods()
            }}
          >
            구매물품 등록 / 수정
          </a>
        </span>
      </div>

      <div className="tbl-wrap">
        <table className="tbl-list">
          <caption>HS부호, 품명, 규격, 수량, 구매일, 단가, 금액 항목으로 구성</caption>
          <colgroup>
            <col style={{ width: '14%' }} />
            <col style={{ width: '23%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '14%' }} />
            <col style={{ width: '12%' }} />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">HS부호</th>
              <th scope="col">품명</th>
              <th scope="col">규격</th>
              <th scope="col">수량</th>
              <th scope="col">구매일</th>
              <th scope="col">
                단가
                <br />({sumInfo?.totamtcur || 'KRW'})
              </th>
              <th scope="col">
                금액
                <br />({sumInfo?.totamtcur || 'KRW'})
              </th>
            </tr>
          </thead>
          <tbody>
            {goodsList?.length > 0 ? (
              goodsList?.map((goods, index) => {
                return (
                  <tr className="row" key={index}>
                    <td data-title={'HS부호'}>{goods?.hsCd}</td>
                    <td data-title={'품명'}>{goods?.itemnm}</td>
                    <td data-title={'규격'}>{goods?.itemdeftxt}</td>
                    <td data-title={'수량'}>{goods?.grcnt && commons.addComma(goods.grcnt)}</td>
                    <td data-title={'구매일'}>{goods?.crtYmd && moment(goods.crtYmd).format('YYYY-MM-DD')}</td>
                    <td data-title={'단가'}>{goods?.baseAmt && commons.addComma(goods.baseAmt)}</td>
                    <td data-title={'금액'}>{goods?.gramt && commons.addComma(goods.gramt)}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className="nodata">등록된 자료가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="list-footer">
        <span className="left">
          <a
            href="#"
            className="btn-secondary md"
            onClick={(e) => {
              e.preventDefault()
              props.doDelete()
            }}
          >
            취소
          </a>
        </span>
        <span className="right">
          <a
            href="#"
            className="btn-secondary md"
            onClick={(e) => {
              e.preventDefault()
              props.goStepPrev()
            }}
          >
            이전
          </a>
          <a
            href="#"
            className="btn-primary md"
            onClick={(e) => {
              e.preventDefault()
              props.goStepNext()
            }}
          >
            다음
          </a>
        </span>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    stepData: state.certapply?.data?.step2,
    totalData: state.certapply.data,
    isCalled: state.certapply.isCalled,
  }
}

const actionCreators = {
  setCalled: certapplyActions.setCalled,
  error: alertActions.error,
  confirm: alertActions.confirm,
  updateCurrency: certapplyActions.updateCurrency,
}

export default connect(mapStateToProps, actionCreators)(Step02)
